module.exports = __webpack_public_path__ + "static/screen_2-761af37f62758460d8e9c966a10b1868.png";